'use client'

import { Switch as SwitchOrigin } from '@mui/material'
import { Colors } from '~/libs/mui/color'
import { theme } from '~/libs/mui/theme'

type Props = {
  value: boolean
  onChange: (value: boolean) => void
}

export const Switch = ({ value, onChange }: Props) => {
  return (
    <SwitchOrigin
      focusVisibleClassName='.Mui-focusVisible'
      disableRipple
      sx={{
        m: '1px',
        width: '38px',
        height: '22px',
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: '2px',
          minHeight: '18px',
          transitionDuration: '300ms',
          color: Colors.color5A5957,
          '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: Colors.color23221F,
            '& + .MuiSwitch-track': {
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: Colors.color23221F,
            border: `6px solid ${Colors.color23221F}`,
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color: Colors.color1A1A18,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: '18px',
          height: '18px',
        },
        '& .MuiSwitch-track': {
          borderRadius: 26 / 2,
          backgroundColor: Colors.color1A1A18,
          opacity: 1,
          transition: theme.transitions.create(['background-color'], {
            duration: 500,
          }),
        },
      }}
      checked={value}
      value={value}
      onChange={(_, value) => onChange(value)}
    />
  )
}
